import page_json from './config/config.json'
import config from '../config';
import { useLocation } from 'react-router-dom';
import ContactForm from "./ContactForm";
import ContactUsButton from './ContactUsButton';
import TechnologyAlliances from "./TechnologyAlliances";
import MarqueeComponent from "./MarqueeComponent";

const textDataUrl = `${page_json.page_jsons.footer}?v=${config.VERSION}`;
const textDataResponse = await fetch(textDataUrl);
const textData = await textDataResponse.json();

const footerlogo = `${page_json.background_img.footerlogo}?v=${config.VERSION}`;
function Footer() {
    const location = useLocation();
    const hideContactForm = location.pathname === '/Contact' || location.pathname === '/About';
    const hideCtoPaths = [
        '/Manufacturing/Plastics-Injection-Molding',
        '/Manufacturing/Ecommerce-Portal',
        '/Healthcare/AI-In-Healthcare',
        '/Healthcare/Digital-Experiences',
        '/Healthcare/Charitable-Organization',
        '/Healthcare/Integrated-User-Experiences',
        '/Financial-Services/AI-Chatbot',
        //'/Financial-Services/Automating-Trade-Systems',
        '/Financial-Services/Financial-Services-Portal',
        '/Financial-Services/FINRA-Compliance',
        '/Resources',
        '/Resources/News',
        '/Resources/Blogs/LiferayCustomDashboard',
        '/Resources/Blogs/JWKS',
        '/Resources/Blogs/MSAL',
        '/Resources/Blogs/Liferay-client-extensions',
        '/Resources/Blogs'
    ];
    const hideCto = hideCtoPaths.includes(location.pathname);
    const isHomePage = location.pathname === '/';
    return (
        <div className="footer-common">
            {!isHomePage && (
            <div className="footer-outer">
                {!hideCto &&
                    <div className="alliances d-flex flex-column justify-content-center align-items-center ">
                        <h1 className="text-white text-center">
                        {textData.startYourDigitalTransformation.heading.text1}
                        <span>{textData.startYourDigitalTransformation.heading.text2}</span>
                        {textData.startYourDigitalTransformation.heading.text3}
                        </h1>
                        <ContactUsButton
                        text={textData.startYourDigitalTransformation.button.text}
                        link="#ContactForm"
                        className="light"
                        />
                    </div>
                }
                <TechnologyAlliances data={textData.alliacessection} />
                {!hideContactForm && <MarqueeComponent assets={textData.clients} />}
                {!hideContactForm && <div id="ContactForm"><ContactForm /></div>}
            </div>
            )}
            <div className="container-fluid ftr">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <div className="media">
                                <a href="https://www.linkedin.com/company/engineersmind/" title="LinkedIn" target="blank"><i className="fab fa-linkedin-in"></i></a>
                                <div className="ftr-logo">
                                    <img src={footerlogo} className="img-fluid" alt="aws" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <div className="links">
                                <p>LINKS</p>
                                <ul>
                                    <li><a href="/Industries/Healthcare">Industries</a></li>
                                    <li><a href="/Services/Digital-Transformation">Services</a></li>
                                    <li><a href="/Technologies/Liferay">Technologies</a></li>
                                    <li><a href="/Resources">Resources</a></li>
                                    <li><a href="/About">About Us</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <div className="links-1">
                                <ul>
                                    <li><a href="/Resources/News">News</a></li>
                                    <li><a href="/Resources/Success-Stories">Success Stories</a></li>
                                    <li><a href="/Resources/Blogs">Blogs</a></li>
                                    <li><a href="/About/Careers">Careers</a></li>
                                    <li><a href="/Contact">Contact</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-2">
                            <div className="policies">
                                <p>POLICY</p>
                                <ul>
                                    <li><a href="/Privacy-Policy">PRIVACY & POLICY</a></li>
                                    <li><a href="/Terms-Of-Use">TERMS OF USE</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-2 col-sm-12 col-xs-4">
                            <div className="address">
                                <p><a href="mailto:solutions@engineersmind.com">solutions@engineersmind.com</a></p>
                                <p style={{width: 'max-content'}}><a href="tel:18882918757">+1 888 291 8757</a></p>
                                <p>Corporate Headquarters</p>
                                <p>Engineersmind Corp</p>
                                <p>185 Hudson Street</p>
                                <p>Jersey City, NJ 07302 USA</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ftr-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className="copy">
                                    <p>&copy; 2025 Engineersmind. All Rights Reserved.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className="powered">
                                    {/* <p>Powered by: lumos.in</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Footer;